/** @format */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { useStyles } from './style';
import { useEffect } from 'react';
import { useQuery } from 'hooks';
import createToast from 'components/Toast/Toast';
import { Empty, PaginationComponenets, PageContainer, SimpleDialog, Icons } from 'components';
import { creditHasTotalInfo } from '../../services/DetailAccountsServices';
import Guild from './components/Guild';
import { CreateDetailAccount } from './components/Guild/components';
import useCustomHook from '../hooks';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const COUNT_DATA_PER_PAGE = 9;
const ListDetailAccounts = () => {
  const classes = useStyles();
  const {
    openDialog,
    setOpenDialog,
    blockAccounts,
    setBlockAccounts,
    accountDetails,
    setAccountDetails,
    totalCount,
    setTotoalCount,
    currentPage,
    setCurrentPage,
    loading,
    setLoading,
    isDisableAll,
    setIsDisableAll,
    mainData,
    setMainData,
  } = useCustomHook();

  const actionsList = getDynamicObjectAction([
    'createNewGuildBtn',
    'contentGuildPage',
    'accountGuildDashboardBtn',
  ]);
  const query = useQuery();
  const paid = query.get('paid');

  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    setLoading(true);
    paginationOnChange({
      page: currentPage === 0 ? 1 : currentPage,
      pageSize: 5,
      pageNumber: currentPage === 0 ? 0 : currentPage - 1,
      changeData: true,
    });
  }, [currentPage]);

  useEffect(() => {
    if (paid) {
      if (paid.toLowerCase() === 'true') {
        createToast('موفق', 'شارژ حساب دیجیتال با موفقیت انجام شد.', 'success');

        query.delete('paid');
        navigate(query.toString(), { replace: true });
      }

      if (paid.toLowerCase() === 'false') {
        createToast('خطا', 'شارژ حساب دیجیتال ناموفق.', 'danger');

        query.delete('paid');
        navigate(query.toString(), { replace: true });
      }
    }
    if (actionsList['contentGuildPage'] || actionsList['accountGuildDashboardBtn']) {
      getList();
    }
  }, []);

  const getList = async () => {
    try {
      setLoading(true);
      const result = await creditHasTotalInfo();
      setBlockAccounts(result?.result?.blockedBusinessAmountSrvs ?? []);
      setAccountDetails((prev) => ({
        blocks: result?.result?.blockedBusinessAmountSrvs,
        wallets: result?.result?.customerAmountSrvs,
        guilds: result?.result?.mainBusinessAmountSrvs.sort((firstEl, secEl) => {
          if (firstEl?.amount > secEl?.amount) return -1;
          if (firstEl?.amount < secEl?.amount) return 1;
          return 0;
        }),
      }));
      setMainData(result?.result?.mainBusinessAmountSrvs);
      setTotoalCount(result?.result?.mainBusinessAmountSrvs?.length);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const createNewGuild = () => {
    setOpenDialog(true);
  };

  const handleSubmit = (message, variant) => {
    if (!message || variant == 'success') {
      setOpenDialog(false);
    }
    if (!message) {
      return;
    }
    if (variant == 'success') {
      getList();
    }

    createToast('موفق', message, 'success');
  };

  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    const currentPageItem = param.page === 0 ? 1 : param.page;

    setTimeout(() => {
      setLoading(false);
    }, 1500);
    if (param?.changeData) setCurrentPage(currentPageItem);
    else return;
  };

  const getPageList = (page) => {
    if (accountDetails?.guilds) {
      const temp = [...accountDetails?.guilds];
      return temp.splice((page - 1) * COUNT_DATA_PER_PAGE, COUNT_DATA_PER_PAGE);
    }
    return [];
  };

  const hint =
    'در این بخش لیست حساب‌های تفصیلی کسب‌وکار شما نمایش داده شده است. این حساب‌های تفصیلی برای دسته‌بندی عملیات مالی شما، به کار می‌روند و محل واریز درآمدهای شما از پرداخت فاکتورهای صادر شده می‌باشد. (ترتیب نمایش براساس بیشترین موجودی می‌باشد.)';
  return (
    <PageContainer
      meta={
        <>
          {actionsList['createNewGuildBtn'] && (
            <Button
              className={classes.cardHeaderButton}
              onClick={() => createNewGuild()}
              color="primary"
              variant="contained"
              startIcon={<Icons icon="plusCircle" color="#fff" size="18" />}
            >
              ایجاد حساب تفصیلی جدید
            </Button>
          )}
        </>
      }
      description={hint}
      title="لیست حساب‌ها "
      breadcrumbs={constBreadCrumbsTitle.GUILD_LIST}
      loading={loading}
      isDisableAll={isDisableAll}
    >
      {(actionsList['contentGuildPage'] || actionsList['accountGuildDashboardBtn']) && (
        <>
          {accountDetails?.guilds?.length === 0 ? (
            <Empty />
          ) : (
            <Guild
              accDetails={accountDetails}
              dataGuild={getPageList(currentPage)}
              refreshList={getList}
              blockAccounts={blockAccounts}
              isDisableAll={isDisableAll}
              setIsDisableAll={setIsDisableAll}
            />
          )}
          {!loading && accountDetails?.guilds?.length > 0 ? (
            <Grid justifyContent="center" container style={{ marginTop: 16 }}>
              <PaginationComponenets
                itemsPerPage={COUNT_DATA_PER_PAGE}
                currentPage={currentPage}
                pageCount={totalCount}
                onChange={paginationOnChange}
                removePrePage={true}
                localCall={true}
              />
            </Grid>
          ) : null}

          {/* Create New Guild */}
          {actionsList['createNewGuildBtn'] && (
            <SimpleDialog
              fullWidth
              maxWidth="sm"
              open={openDialog}
              icon={<Icons icon="wallet" color="#2B3990" size="20" />}
              title="ایجاد حساب تفصیلی جدید"
              onClose={() => handleSubmit()}
            >
              <CreateDetailAccount onSubmitEnd={handleSubmit} />
            </SimpleDialog>
          )}
        </>
      )}
    </PageContainer>
  );
};

export default ListDetailAccounts;
